import CloseIcon from '@mui/icons-material/Close';
import AppBar from '@mui/material/AppBar';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import LinearProgress from '@mui/material/LinearProgress';

import { dialogManager } from '../stores/DialogManager';

import Dialog from '@egr/xbox/egr-gui-dialogs/utils/DialogOverride';
import { ToolbarLabel } from '@egr/xbox/egr-gui-elements/Toolbar/ToolbarLabel';
import { TopToolbar } from '@egr/xbox/egr-gui-elements/Toolbar/TopToolbar';
import { DialogTransition } from '@egr/xbox/egr-gui-elements/single-components/DialogTransition';
import { corsProxyUrl } from '@egr/xbox/utils/Services';
import { makeStyles } from '@egr/xbox/utils/tss-react';

const useYoutubeLoadingDialogStyles = makeStyles({ name: 'YoutubeLoadingDialog' })((theme) => ({
    background: {
        backgroundColor: '#000000',
    },
    text: {
        color: '#fff',
    },
    noPadding: {
        padding: 0,
    },
    appBar: {
        background: theme.palette.background.default,
        color: theme.palette.text.secondary,
        backgroundColor: '#000000',
    },
    image: {
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
        [theme.breakpoints.up('sm')]: {
            maxHeight: '90%',
        },
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
}));

export const YoutubeLoadingDialog: React.FC = () => {
    const { classes } = useYoutubeLoadingDialogStyles();
    const { youtubeLinkId, youtubeTitle, youtubeDialogOpen } = dialogManager.useState(['youtubeDialogOpen', 'youtubeTitle', 'youtubeLinkId']);

    const isBuffering = youtubeDialogOpen && !!youtubeLinkId;

    if (!isBuffering || !youtubeLinkId) return null;

    const thumbnailStem: string = corsProxyUrl(`https://img.youtube.com/vi/${youtubeLinkId}/`);

    const close = (): void => {
        dialogManager.closeYoutube();
    };

    return (
        <Dialog
            fullWidth
            fullScreen
            open={isBuffering}
            onClose={close}
            className={classes.background}
            TransitionComponent={DialogTransition}
        >
            <AppBar
                position="static"
                className={classes.appBar}
            >
                <TopToolbar className={classes.text}>
                    <IconButton
                        onClick={close}
                        edge="start"
                        className={classes.text}
                        size="large"
                    >
                        <CloseIcon />
                    </IconButton>
                    <ToolbarLabel>{youtubeTitle}</ToolbarLabel>
                </TopToolbar>
            </AppBar>
            <DialogContent className={`${classes.background} ${classes.noPadding}`}>
                <LinearProgress
                    className={classes.background}
                    style={{ zIndex: 1 }}
                />
                <div style={{ height: '100%' }}>
                    <object
                        className={classes.image}
                        data={thumbnailStem + 'sddefault.jpg'}
                        type="image/jpg"
                    >
                        <img
                            className={classes.image}
                            src={thumbnailStem + 'hqdefault.jpg'}
                            alt="YouTube thumbnail"
                        />
                    </object>
                </div>
            </DialogContent>
        </Dialog>
    );
};

YoutubeLoadingDialog.displayName = 'YoutubeLoadingDialog';
